<template>
    <v-app class="default-layout">
        <slot name="header" />
        <main class="app">
            <div class="constrained-width">
                <FeatureFlagApp>
                    <slot name="app" />
                    <template #loading>
                        <NsSpinner class="flag-loader" />
                    </template>
                </FeatureFlagApp>
            </div>
        </main>
        <slot name="footer" />
    </v-app>
</template>


<script>
import {FeatureFlagApp} from '@nuskin/ns-feature-flags-vue';
import {NsSpinner} from '@nuskin/design-components';
import {VApp} from 'vuetify/lib';


export default {
    components: {
        FeatureFlagApp,
        NsSpinner,
        VApp
    }
};
</script>
<style lang="scss" scoped>
@use 'sass:map';
@use '~@nuskin/ns-core-styles/src/scss/colors';
@use '~@nuskin/ns-core-styles/src/scss/global.mixins.scss';
@import '~/assets/variables.scss';

.default-layout {
 background: map.get(colors.$theme, 'primary-background')
}

.app {
  @include global.phone {
    flex-grow: 1;
  }
  padding: $viewport-padding;
}
.constrained-width {
  width: 100%;
  max-width: $mobile-max-width;
  margin-left: auto;
  margin-right: auto;
}
.flag-loader {
  margin-left: auto;
  margin-right: auto;
}
.back-to-profile-wrapper {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
}

</style>

